import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    headerGrid: {
        paddingTop: '2rem',
        paddingLeft: '1rem',
        textAlign: 'center'
    },
    paper: {
        maxWidth: '1005px',
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(1),
        border: '5px solid #000'
    },
    container: {
        maxHeight: 440,
    },
    th: {
        backgroundColor: '#0F7DB0'
    },
    th_text: {
        color: theme.palette.common.white,
        fontWeight: 'bold'
    }
})

class RainAlarmTableComponent extends React.Component {
    render() {
        const { classes } = this.props
        return (
            <Grid container direction="row">
                <Grid item xs={12} className={classes.headerGrid}>
                    <Typography variant="h4">
                        Rain & Level Alarm
                    </Typography>
                </Grid>

                <Grid item xs={12} style={{ padding: '1rem' }}>
                    <Paper className={classes.paper}>
                        {this.props.data.length ?
                            <TableContainer className={classes.container}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Rain Alarm</TableCell>
                                            <TableCell>Level Alarm</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    {this.props.data.map(x => (
                                        <TableBody key={x.location}>
                                            <TableRow className={classes.th}>
                                                <TableCell className={classes.th_text}
                                                    style={{ width: '50%' }}>
                                                    {x.location}
                                                </TableCell>
                                                <TableCell className={classes.th_text}
                                                    style={{ width: '50%', textAlign: 'right' }}>
                                                    (From {x.date_time})
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                {x.rain_alarm_indicator === "Heavy Rain" ?
                                                    <TableCell>
                                                        <Typography style={{ fontWeight: 'bold', color: 'orange' }}>
                                                            Heavy Rain - {x.rain_alarm}mm
                                                        </Typography>
                                                    </TableCell>
                                                    :
                                                    <TableCell>{x.rain_alarm}</TableCell>
                                                }

                                                {x.level_alarm_indicator === "Alert" ?
                                                    <TableCell>
                                                        <Typography style={{ fontWeight: 'bold', color: 'green' }}>
                                                            Alert - {x.level_alarm}mm
                                                        </Typography>
                                                    </TableCell>
                                                    :
                                                    x.level_alarm_indicator === "Warning" ?
                                                        <TableCell>
                                                            <Typography style={{ fontWeight: 'bold', color: 'orange' }}>
                                                                Warning - {x.level_alarm}mm
                                                            </Typography>
                                                        </TableCell>
                                                        :
                                                        x.level_alarm_indicator === "Danger" ?
                                                            <TableCell>
                                                                <Typography style={{ fontWeight: 'bold', color: 'red' }}>
                                                                    Danger - {x.level_alarm}mm
                                                                </Typography>
                                                            </TableCell>
                                                            :
                                                            <TableCell>{x.level_alarm}</TableCell>
                                                }
                                            </TableRow>
                                        </TableBody>
                                    ))}
                                </Table>
                            </TableContainer>
                            :
                            <Grid container alignItems="center" justify="center">
                                <CircularProgress />
                            </Grid>
                        }
                    </Paper>
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(styles, { withTheme: true })(RainAlarmTableComponent);